import { Box, Grid, IconButton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Order } from '../Models/Orders'
import { CancelOutlined } from '@mui/icons-material'
import { ApiGetOrderById } from '../Core/Apicall'
import { useNavigate, useParams } from 'react-router-dom'
import { VariantImage } from '../Models/Varient'

function OrderDetails() {
    const [selectedOrder, setSelectedOrder] = useState<Order | null>(null)
    const { orderId } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        const getOrder = async () => {
            try {
                const data = `?orderId=${orderId}`
                const res = await ApiGetOrderById(data)
                if (res?.success) {
                    setSelectedOrder(res?.data)
                }
            } catch (error) {

            }
        }
      orderId &&  getOrder()
    }, [orderId])
    return (
        selectedOrder && (
            <Grid size={{ xs: 12, lg: 3 }} className='border-main border-10 m-2 m-md-0 h-100'>
                <Box className='bg-grey text-white d-flex align-items-centers justify-content-between w-100 p-3 fs-18 fw-bold'>
                    <Typography className='text-white fs-18 fw-bold'> Order Details</Typography>
                    <IconButton className='m-0 p-0' onClick={() => {navigate(-1)}}><CancelOutlined className='text-white' /></IconButton>
                </Box>
                <Box className='mt-3 p-2 px-3'>
                    <Box className='mb-2 d-flex align-items-start gap-3'>
                        <Box>
                            <Typography className='fs-14 text-grey'>Order ID</Typography>
                            <Typography className='fs-14 text-white'>{selectedOrder?.order_number}</Typography>
                        </Box>
                        <Typography className='fs-14 px-2  py-1 fw-semibold btn-light-yellow' style={{ width: 'fit-content' }}>{selectedOrder?.order_status}</Typography>
                    </Box>
                    <Box>
                        <Typography className='fs-14 text-grey'>Placed on</Typography>
                        <Typography className='fs-14 text-white'>{new Date(selectedOrder?.created_at).toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric',
                        })}</Typography>
                    </Box>

                    <Box className='mt-3'>
                        <Typography className='fw-bold fs-16 text-white' gutterBottom>Shipping Address</Typography>
                        <Typography className='fs-14 text-white'>{selectedOrder?.shipping_address?.address_line_1}, {selectedOrder?.shipping_address?.address_line_2}, {selectedOrder?.shipping_address?.city}, {selectedOrder?.shipping_address?.state} - {selectedOrder?.shipping_address?.postal_code}</Typography>
                        <Typography className='fs-14 text-white' gutterBottom>{selectedOrder?.shipping_address?.country}</Typography>
                        <Typography className='fs-14 text-white' gutterBottom>{selectedOrder?.shipping_address?.mobile_number}</Typography>
                    </Box>

                    <hr className='border-main' />
                    <Box className='d-flex align-items-start justify-content-between'>
                        <Box>
                            <Typography className='fs-16 fw-bold text-white' gutterBottom>Payment Method</Typography>
                            <Typography className='text-white fs-14'>**** **** **** 4242</Typography>
                            <Typography className='fs-12 text-grey'>paid via Credit Card</Typography>
                        </Box>
                        <Typography className='fs-18 fw-bold text-white'>${selectedOrder?.total_amount}</Typography>
                    </Box>

                    <hr className='border-main' />
                    <Box className='mb-2'>
                        <Typography className='fs-16 fw-bold text-white' gutterBottom>Order Items ({selectedOrder?.items?.length})</Typography>
                        {selectedOrder?.items?.map((item) => (
                            <Box className='d-flex align-items-center gap-3 mb-2'>
                                <Box component={'img'} height={'50px'} width={'50px'} className='border-10' src={item?.variant?.variantImages?.find((item: VariantImage) => item?.is_thumbnail == true)?.image_url || item?.variant?.variantImages[0].image_url} />
                                <Box className='d-flex align-items-center justify-content-between flex-1'>
                                    <Typography className='text-white fs-14'>{item?.variant?.name}</Typography>
                                    <Typography className='fs-12 text-grey'>Qty: <span className='text-white'>{item?.quantity}</span></Typography>
                                    <Typography className='fs-14 fw-bold text-white'>${item?.total_price}</Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                    <hr className='border-main' />
                    <Box>
                        <Box className='d-flex align-items-center justify-content-between'>
                            <Typography className='text-white fs-14'>Subtotal ({selectedOrder?.items?.length} items)</Typography>
                            <Typography className='text-white fs-16'>${selectedOrder?.subtotal}</Typography>
                        </Box>
                        <Box className='d-flex align-items-center justify-content-between'>
                            <Typography className='text-white fs-14'>Tax(5%)</Typography>
                            <Typography className='text-white fs-16'>${selectedOrder?.tax_amount}</Typography>
                        </Box>
                        <Box className='d-flex align-items-center justify-content-between'>
                            <Typography className='text-white fs-14'>Discount</Typography>
                            <Typography className='text-white fs-16'>${selectedOrder?.discount_amount}</Typography>
                        </Box>
                        <Box className='d-flex align-items-center justify-content-between'>
                            <Typography className='text-white fs-14'>Delivery Fee</Typography>
                            <Typography className='text-white fs-16'>${selectedOrder?.shipping_amount}</Typography>
                        </Box>
                        <hr className='border-main' />
                        <Box className='d-flex align-items-center justify-content-between'>
                            <Typography className='text-white fs-18 fw-bold'>Total</Typography>
                            <Typography className='text-white fs-20'>${selectedOrder?.total_amount}</Typography>
                        </Box>
                    </Box>

                </Box>
            </Grid>
        )
    )
}

export default OrderDetails
